import React from "react";
import { CATEGORIES, emojiFor } from "@/lib/categories";
import { useLang } from "@/context/LanguageContext";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export default function CategorySelect({ value, onChange, testid = "category-select" }) {
  const { t, lang } = useLang();
  // Strict alphabetical order by translated label (every category, incl. "Autres").
  const items = React.useMemo(() =>
    [...CATEGORIES].sort((a, b) =>
      t(`cat.${a.key}`).localeCompare(t(`cat.${b.key}`), lang, { sensitivity: "base" })),
  [t, lang]);

  return (
    <Select value={value || undefined} onValueChange={(v) => { if (v) onChange(v); }}>
      <SelectTrigger data-testid={testid} className="h-12 rounded-full">
        {value ? (
          <span className="flex items-center gap-2.5">
            <span style={{ fontSize: "28px", lineHeight: 1 }} aria-hidden="true">{emojiFor(value)}</span>
            <span>{t(`cat.${value}`)}</span>
          </span>
        ) : (
          <SelectValue placeholder={t("cat.placeholder")} />
        )}
      </SelectTrigger>
      <SelectContent className="max-h-72 cat-scroll">
        {items.map((c) => (
          <SelectItem key={c.key} value={c.key} data-testid={`category-option-${c.key}`}>
            <span className="flex items-center gap-2.5">
              <span style={{ fontSize: "28px", lineHeight: 1 }} aria-hidden="true">{emojiFor(c.key)}</span>
              {t(`cat.${c.key}`)}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
